namespace Recommendations  {

    interface GetHotelsForLandingOptions {
        imgWidth?: number|undefined;
    }

    interface GetDestinationsForLandingOptions {
        imgWidth?: number|undefined;
    }

    function Recommender (
        $q: ng.IQService,
        $http: ng.IHttpService,
        $window: ng.IWindowService,
        broker: Core.Broker,
        fieldGroupService: Core.FieldGroupService,
        imageService: any,
        bd4travel: any,
        bd4Helper: any,
        destinationService: any,
        occupancyService: Core.OccupancyService,
        recommenderTracker: any
    )
    {
        const IMAGE_WIDTH = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
        const IMAGE_HEIGHT = 200;
        const HOTEL_PROPERTIES = 'Country,CustomerRating,CustomerRatingCount,Id,Province,StarRating,Title,Url';
        const HOTEL_FIELDS = [ Core.FieldType.Global, Core.FieldType.Titles, Core.FieldType.Characteristics,
            Core.FieldType.Destinations, Core.FieldType.Url, Core.FieldType.IndicativePrice ];
        //This needs to be versioned whenever the cookie serialization format changes.
        const COOKIE_NAME = 'reco_search_3';
        const DESTINATIONS_MAX = 3;
        const HOTEL_SUGGESTIONS_MAX = 16;
        const DESTINATION_SUGGESTIONS_MAX = 64;

        let cookie = (function() {
            let _cookie: SearchCookie;
            return function (values?: SearchCookie): SearchCookie {
                if (values) {
                    // set _cookie
                    _cookie = values;
                    const expiration = new Date();
                    expiration.setMinutes(expiration.getMinutes() + 10);
                    let destinations = _(values.destinations).map(d => d.fullyQualifiedId).join('_').replace(/:/g, '-');
                    document.cookie =
`${COOKIE_NAME}=${values.guid}|${destinations}; expires=${expiration.toUTCString()}; path=/`;
                }
                if (!_cookie) {
                    // get _cookie
                    const cookieValues = document.cookie.match(`${COOKIE_NAME}=(.*?);`);
                    if (cookieValues) {
                        const split = cookieValues[1].split('|');
                        let destinations: Bd4Destination[] =
                            _.map((split[1] || '').replace(/-/g, ':').split('_'), Bd4Destination) as any;
                        _cookie = {
                            guid: split[0] || '',
                            destinations
                        };
                    }
                }
                return _cookie || {
                    guid: '',
                    destinations: []
                };
            };
        })();

        broker.subscribe('recommender', 'recommender.startSearch', ({ data }) => {
            const toHotelPage = new Bd4Destination(data).Type === 1;
            const placementId = createPlacementId(data.isHotel, toHotelPage);
            startSearch(data.searchModel, data.isHotel, placementId);
        });

        function startSearch(searchModel, isHotel, placementId) {
            let destinations;
            let bd4Destination = new Bd4Destination(searchModel);
            return validate(searchModel, placementId)
                .then(() => {
                    if (isHotel) {
                        //This context is used for bd4's tracking:
                        let context = bd4travel.getContextFromSearch(searchModel, isHotel);
                        return bd4Helper.getRecommendedDestinations(placementId, context, bd4Destination, 5);
                    } else {
                        return [bd4Destination];
                    }
                })
                .then(x => {
                    if (x.length > 1) {
                        destinations = x.filter(x => x.fullyQualifiedId !== bd4Destination.fullyQualifiedId);
                    } else {
                        destinations = x;
                    }
                })
                .then(() => $http.post(
                    '/api/hotels/availability/searchbymultipledestinations',
                    {
                        CultureCode: TRPCONFIG.Domain.CultureCode,
                        CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                        Destinations: destinations,
                        DomainId: TRPCONFIG.Domain.DomainId,
                        CheckInDate: _.get(searchModel, 'startDate'),
                        CheckOutDate: _.get(searchModel, 'endDate'),
                        Rooms: _.get(searchModel, 'occupancy'),
                        IsFlightPlus: !isHotel
                    },
                    { ignoreErrors: true }
                ))
                .then(res => {
                    cookie({guid: res.data, destinations});
                });
        }

        function continueSearch(currentEstab, searchModel, isHotel, placementId, tripId) {
            let cookieValues, token;
            let promise =
                validate(searchModel, placementId)
                    .then(() => cookie().guid || startSearch(searchModel, isHotel, placementId))
                    .then(() => cookieValues = cookie())
                    .then(() => bd4travel.getContextFromSearch(searchModel, isHotel))
                    .then(context => bd4Helper.getRecommendations(
                        placementId, HOTEL_SUGGESTIONS_MAX, context, cookieValues.destinations))
                    .then(({ estabIds, ptoken }) => {
                        token = ptoken;
                        return $http.post(
                            `/api/hotels/availability/gethotelsbyid?fields=${HOTEL_PROPERTIES},MinCost&testing=1`,
                            {
                              AvailabilitySearchId: cookieValues.guid,
                              CultureCode: TRPCONFIG.Domain.CultureCode,
                              CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                              EstabIds: estabIds,
                              TripId: tripId,
                              FieldFlags: fieldGroupService.getFieldGroup(
                                  ...HOTEL_FIELDS.concat([Core.FieldType.Pricing]))
                            },
                            { ignoreErrors: true }
                        );
                    })
                    .then(_.partialRight(_.get, 'data'))
                    .then(_.partialRight(_.filter, h => h.Id !== currentEstab))
                    .then(_.partialRight(_.take, 8))
                    .then(addHotelDetails)
                    .then(hotels => ({ hotels, placementId, token }));

            return recommenderTracker.appendHotelTracking(promise);
        }

        function getHotelsForLanding(placementId, options: GetHotelsForLandingOptions = {}) {
            let token;
            const promise = bd4Helper.getRecommendations(placementId, HOTEL_SUGGESTIONS_MAX)
                .then(({ estabIds, ptoken }) => {
                    token = ptoken;
                    if (_.isUndefined(estabIds) || _.isEmpty(estabIds)) { return $q.resolve([]); }
                    return $http.post(
                        `/api/hotels/static/gethotelsbyid?fields=${HOTEL_PROPERTIES},IndicativeMinPrice&testing=1`,
                        {
                            Ids: estabIds,
                            CultureCode: TRPCONFIG.Domain.CultureCode,
                            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                            DomainId: TRPCONFIG.Domain.DomainId,
                            FieldFlags: fieldGroupService.getFieldGroup(...HOTEL_FIELDS)
                        },
                        { ignoreErrors: true }
                    );
                })
                .then(_.partialRight(_.get, 'data'))
                .then(_.partialRight(_.filter, h => h.IndicativeMinPrice > 0))
                .then(_.partialRight(_.take, 8))
                .then(_.partialRight(addHotelDetails, options))
                .then(hotels => ({ hotels, placementId, token }));

            return recommenderTracker.appendHotelTracking(promise);
        }

        function addDestinationDetails(destinations, options) {
            return destinations.map(destination => ({
                ...(_.omit(destination, 'Title')),
                Title: destination.Province,
                ImageUrl: destinationService.destinationThumb(destination)
            }));
        }

        function getDestinationsForLanding(
            placementId, landingOptions: GetDestinationsForLandingOptions = {}, destination) {
            let token;
            const promise = bd4Helper.getRecommendations(placementId, DESTINATION_SUGGESTIONS_MAX)
                .then(({ estabIds, ptoken }) => {
                    token = ptoken;
                    if (_.isUndefined(estabIds) || _.isEmpty(estabIds)) { return $q.resolve([]); }
                    return $http.post(
                        `/api/hotels/static/gethotelsbyid?fields=${HOTEL_PROPERTIES},ProvinceId&testing=1`,
                        {
                            Ids: estabIds,
                            CultureCode: TRPCONFIG.Domain.CultureCode,
                            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                            DomainId: TRPCONFIG.Domain.DomainId,
                            FieldFlags: fieldGroupService.getFieldGroup(...HOTEL_FIELDS)
                        },
                        { ignoreErrors: true }
                    );
                })
                .then(_.partialRight(_.get, 'data'))
                .then(_.partialRight(_.uniqBy, 'ProvinceId'))
                .then(_.partialRight(_.take, DESTINATIONS_MAX))
                .then(_.partialRight(addDestinationDetails, landingOptions))
                .then(destinations => ({ destinations, placementId, token }));

            return recommenderTracker.appendDestinationTracking(promise);
        }

        function createPlacementId(isHotel: boolean, toHotelPage: boolean): string {
            return `${isHotel ? 'HOTELS' : 'HOLIDAYS'}_${toHotelPage ? 'SELECT_ROOM': 'HOTELS_LIST'}`;
        }

        function validate(searchModel, placementId: string) {
            let isPlacementIdEnabled = _.includes(TRPCONFIG.Domain.BD4TRecommenders, placementId);
            let destination =
                searchModel &&
                searchModel.destination &&
                (searchModel.destination[0] || searchModel.destination);

            let isValid = searchModel && placementId && isPlacementIdEnabled &&
                !_.isEmpty(destination) && searchModel.startDate;

            return isValid ? $q.when() : $q.reject();
        }

        function addHotelDetails(hotels, options: GetHotelsForLandingOptions = {}) {
            return _.map(hotels, (h:any, idx) => {
                h.ImageUrl = imageService.getMainImageUrl(h.Id, options.imgWidth || IMAGE_WIDTH, IMAGE_HEIGHT);
                h.Position = idx;

                let minCost = h.MinCost || h.IndicativeMinPrice;
                if (minCost) {
                    const people = occupancyService.getNumberOfNonInfantPassengers();
                    h.PricePerPerson = minCost / people;
                    h.TotalPrice = minCost;
                }
                return h;
            });
        }

        return {
            startSearch,
            continueSearch,
            createPlacementId,
            getHotelsForLanding,
            getDestinationsForLanding
        };
    }

    angular
        .module('recommendations')
        .service('recommender', Recommender);
}
